import { ResumeData } from ".";

export const sampleResume: ResumeData = {
  "basics": {
    "url": {
      "href": "https://www.linkedin.com",
      "label": ""
    },
    "name": "John Doe",
    "email": "xyz@gmail.com",
    "phone": "+91 124 456 7890",
    "picture": {
      "url": "",
      "size": 64,
      "effects": {
        "border": false,
        "hidden": false,
        "grayscale": false
      },
      "aspectRatio": 1,
      "borderRadius": 0
    },
    "headline": "Mathura, Uttar Pradesh 281001",
    "location": "Punjab",
    "customFields": []
  },
  "metadata": {
    "css": {
      "value": ".section {\n\toutline: 1px solid #000;\n\toutline-offset: 4px;\n}",
      "visible": false
    },
    "page": {
      "format": "a4",
      "margin": 18,
      "options": {
        "breakLine": true,
        "pageNumbers": true
      }
    },
    "notes": "",
    "theme": {
      "text": "#000000",
      "primary": "#000000",
      "background": "#ffffff"
    },
    "layout": [
      [
        [
          "summary",
          "internship",
          "experience",
          "projects",
          "certifications",
          "extracurriculars",
          "languages",
          "skills",
          "education"
        ],
        [
          "profiles",
          "interests",
          "volunteer",
          "references",
          "awards",
          "publications"
        ]
      ]
    ],
    "template": "lpu three",
    "typography": {
      "font": {
        "size": 11.9,
        "family": "Montserrat",
        "subset": "latin",
        "variants": [
          "700",
          "regular"
        ]
      },
      "hideIcons": false,
      "lineHeight": 1.5,
      "underlineLinks": true
    }
  },
  "sections": {
    "awards": {
      "id": "awards",
      "name": "Awards",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "custom": {},
    "skills": {
      "id": "skills",
      "name": "Skills",
      "items": [
        {
          "id": "uyaav7eukhwm8zh29pbd798e",
          "name": "Languages C++, Java, JavaScript",
          "level": 1,
          "visible": true,
          "keywords": [],
          "description": ""
        },
        {
          "id": "rxa4t6s51gc3lzbhmzcmyyn2",
          "name": "Technologies/Frameworks:",
          "level": 1,
          "visible": true,
          "keywords": [],
          "description": "Angular, Jasmine Testing, React JS, Node JS, Git, GitHub, Ubuntu"
        },
        {
          "id": "x7erri63q77d3bmk8puubrvj",
          "name": "Domain Skills:",
          "level": 1,
          "visible": true,
          "keywords": [],
          "description": "Data Structures and Algorithms, Problem-Solving, Responsive Web Design, Scripting in Python and JavaScript"
        }
      ],
      "columns": 1,
      "visible": true
    },
    "summary": {
      "id": "summary",
      "name": "Summary",
      "columns": 1,
      "content": "",
      "visible": true
    },
    "profiles": {
      "id": "profiles",
      "name": "Profiles",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "projects": {
      "id": "projects",
      "name": "Projects",
      "items": [
        {
          "id": "pdm2utva6fdw9od9oza1f38e",
          "url": {
            "href": "",
            "label": ""
          },
          "date": "Jul 2022 - Aug 2022",
          "name": "Fkart App | MERN Stack, Responsive Web Design",
          "summary": "<ul><li><p>Developed an e-commerce platform wherein users can buy numerous products such as electronics, clothing, and more.</p></li><li><p>It offers dynamic data from MongoDB, responsive design, dynamic pagination based on data, and developer REST APIs</p></li><li><p>for insertion, retrieval, deletion of data, user authentication, individual user data storage, and other advanced tasks.</p></li><li><p>Applied MERN stack knowledge successfully to create a fully functional MERN stack website.</p></li><li><p>Repository Link: <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://github.com/suraj-singh12/flipkart-project\">https://github.com/suraj-singh12/flipkart-project</a></p></li></ul>",
          "visible": true,
          "keywords": [],
          "location": "",
          "description": ""
        },
        {
          "id": "f3ngsrd0s764o7c3o2lr0s8b",
          "url": {
            "href": "",
            "label": ""
          },
          "date": "Feb 2021 - Mar 2023",
          "name": "Project SearchEverywhere | Python3, Linux, Grep, Open Office, Bash, MS Office",
          "summary": "<ul><li><p>Designed an open-source Linux tool that allows users to search for specific information in multiple file of types including documents, presentations, spreadsheets, and text files.</p></li><li><p>This is an enhancement to the ‘grep‘ command on Linux systems which only allows searching in text files only.</p></li><li><p>Used extensively by students for preparation of university exams during COVID-19 times.</p></li><li><p>Repository Link: <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://github.com/suraj-singh12/Project-SearchEverywhere\">https://github.com/suraj-singh12/Project-SearchEverywhere</a></p></li></ul>",
          "visible": true,
          "keywords": [],
          "location": "",
          "description": ""
        }
      ],
      "columns": 1,
      "visible": true
    },
    "education": {
      "id": "education",
      "name": "Education",
      "items": [
        {
          "id": "rqitwngoou5bfngnxu9ft9w8",
          "url": {
            "href": "",
            "label": ""
          },
          "program": "",
          "area": "Phagwara, Punjab",
          "date": "2020 – 2024",
          "score": "CGPA: 9.23",
          "summary": "",
          "visible": true,
          "studyType": "Bachelor of Technology - Computer Science and Engineering ",
          "institution": {
            "label": "Lovely Professional University",
            "href": ""
          }
        },
        {
          "id": "xlkwvr1f0otumx0ettvph4ip",
          "url": {
            "href": "",
            "label": ""
          },
          "program": "",
          "area": "Mathura, Uttar Pradesh",
          "date": "2018 – 2019",
          "score": "",
          "summary": "",
          "visible": true,
          "studyType": "12th — Percentage: 94.60%",
          "institution": {
            "label": "Kendriya Vidyalaya Mathura Cantt",
            "href": ""
          }
        },
        {
          "id": "tin01sh1p5pd4cbroyen8fr4",
          "url": {
            "href": "",
            "label": ""
          },
          "program": "",
          "area": "Shahjahanpur, Uttar Pradesh",
          "date": "2016 – 2017",
          "score": "",
          "summary": "",
          "visible": true,
          "studyType": "10th — CGPA: 10",
          "institution": {
            "label": "Kendriya Vidyalaya Shahjahanpur Cantt",
            "href": ""
          }
        }
      ],
      "columns": 1,
      "visible": true
    },
    "interests": {
      "id": "interests",
      "name": "Interests",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "languages": {
      "id": "languages",
      "name": "Languages",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "volunteer": {
      "id": "volunteer",
      "name": "Volunteering",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "extracurriculars": {
      "id": "extracurriculars",
      "name": "Extra-curriculars",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "experience": {
      "id": "experience",
      "name": "Experience",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "internship": {
      "id": "internship",
      "name": "Internship",
      "items": [
        {
          "id": "l3peeemxc2zmnmlp9t40tqsz",
          "date": "May 2023 - Jul 2023",
          "company": {
            "label": "SEP Intern | Tableau, SAP, DNS, SSL Certification, CNAME",
            "href": ""
          },
          "companyDescription": "",
          "summary": "<ul><li><p>Contributed to the advancement of the organization's robust <strong>Document Manager</strong> web application.</p></li><li><p>Improved user experience and productivity by implementing comprehensive <strong>row grouping</strong>, <strong>columnfiltering</strong>, and <strong>data filtering</strong> functionality using <strong>Angular Ag-Grid</strong>, enabling easier and faster navigation to relevant records.</p></li><li><p>Enhanced application performance, improved records' load time, and increased overall efficiency by implementing <strong>server-side pagination</strong>, and <strong>nested child pagination</strong>.</p></li><li><p>Wrote <strong>Angular unit test </strong>cases using t h e <strong>Jasmine framework</strong> to validate the <strong>responsiveness of the grid</strong> on different resolutions, evaluate the <strong>functionality of row groupingand data filtering code</strong>, and verify the <strong>accuracy of API calls to the database</strong>. Created mocks, stubs, and spies, ensuring the isolation of dependencies and simulation of diverse scenarios for robust and stable code.</p></li></ul>",
          "visible": true,
          "location": "",
          "position": "JP Morgan Chase & Co."
        },
        {
          "id": "zphhnrdesalgeu1lgca9abhq",
          "date": "Feb 2022 - Aug 2022",
          "company": {
            "label": "Full Stack Web Developer Intern | Tableau, SAP, DNS, SSL Certification, CNAME",
            "href": ""
          },
          "companyDescription": "",
          "summary": "<ul><li><p>Built two dynamic web applications, Flipkart Clone and Zomato Clone, leveraging the power of t he MERN stack.</p></li><li><p>Automated web data collection through software tools and custom scripts, streamlining repetitive tasks effectively.</p></li></ul>",
          "visible": true,
          "location": "",
          "position": "Edureka"
        }
      ],
      "columns": 1,
      "visible": true
    },
    "references": {
      "id": "references",
      "name": "References",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "publications": {
      "id": "publications",
      "name": "Publications",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "certifications": {
      "id": "certifications",
      "name": "Certificate / Certifications",
      "items": [
        {
          "id": "angpnefgj17vi9gjkys7blzs",
          "url": {
            "href": "https://www.udemy.com/",
            "label": ""
          },
          "date": "",
          "name": "Full Stack Web Development",
          "issuer": "Udemy",
          "summary": "",
          "visible": true
        },
        {
          "id": "f6x3wpfkxfok06cbv5o4pbq2",
          "url": {
            "href": "https://www.udemy.com/",
            "label": ""
          },
          "date": "",
          "name": "Linux for Developers Mar 2021",
          "issuer": "Udemy",
          "summary": "",
          "visible": true
        }
      ],
      "columns": 1,
      "visible": true
    }
  }
};
